/**
 * useRecentlyPrinted - Recently printed garments for idle state
 *
 * Fetches up to 10 most recently printed garments at the current location.
 * Same query config pattern as packing station's useRecentlyPacked.
 *
 * @param locationId - The location ID to fetch for, or null
 * @returns TanStack Query result with recently printed items
 */
import { trpc } from '@/lib/trpc';
import { skipToken } from '@tanstack/react-query';

export function useRecentlyPrinted(locationId: string | null) {
  return trpc.printStation.getRecentlyPrinted.useQuery(
    locationId ? { locationId } : skipToken,
    {
      staleTime: 15_000,
      refetchInterval: 30_000,
      refetchIntervalInBackground: false,
      refetchOnWindowFocus: true,
    }
  );
}
